<template>
  <b-modal
    id="add-or-update-event-block"
    :visible="isAddOrUpdateActive"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    hide-header
    @hidden="resetForm"
    @hide="resetForm"
    @change="(val) => $emit('update:is-add-or-update-active', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header py-1"
          style="border-bottom: 1px solid #000000"
        >
          <h5
            class="mb-0"
            style="font-weight: 400; font-size: 14px; line-height: 160%"
          >
            {{ isUpdate ? "Update Designation" : "Add New Designation" }}
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <validation-observer
          #default="{ handleSubmit }"
          ref="update_modal_form"
        >
          <b-form
            class="my-1"
            @submit.prevent="handleSubmit(onCreateOrUpdate)"
            @reset.prevent="resetForm"
          >
            <b-alert v-if="errorMessage" variant="danger" :show="true">
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>

            <!-- UPDATING -->

            <div v-if="isUpdate">
              <validation-provider
                #default="validationContext"
                name="member_type"
                rules="required"
              >
                <b-form-group
                  label="Member Type"
                  label-for="member_type"
                  autofocus
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    v-model="update_data.member_type_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="participantTypes"
                    :reduce="(val) => val.value"
                    :clearable="false"
                    input-id="member_type"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <div>
                <validation-provider
                  #default="validationContext"
                  name="designation"
                  rules="required"
                >
                  <b-form-group label="Designation" label-for="designation">
                    <b-form-input
                      id="designation"
                      v-model="update_data.designation"
                      :state="getValidationState(validationContext)"
                      placeholder=""
                      :disabled="disableForm"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </div>

              <b-form-group label="Is this COP Area Head?" label-for="is_cop_area_head" class="mb-2">
                <validation-provider
                  #default="{ errors }"
                  name="is_cop_area_head"
                  rules=""
                >
                  <b-form-checkbox
                    id="is_cop_area_head"
                    v-model="update_data.is_cop_area_head"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>


            <!-- ADDING -->

            <div v-else>
              <b-row>
                <b-col cols="9">
                  <validation-provider
                    #default="validationContext"
                    name="member_type"
                    rules="required"
                  >
                    <b-form-group
                      label="Member Type"
                      label-for="member_type"
                      autofocus
                      :state="getValidationState(validationContext)"
                    >
                      <v-select
                        v-model="new_data.member_type_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="participantTypes"
                        :reduce="(val) => val.value"
                        :clearable="false"
                        input-id="member_type"
                      />
                      <b-form-invalid-feedback
                        :state="getValidationState(validationContext)"
                      >
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>

              <!-- Designations -->
              <div v-for="(data, index) in new_data.designations" :key="index">
                <b-row>
                  <b-col cols="9" class="px-1">
                    <validation-provider
                      #default="validationContext"
                      name="designation"
                      rules="required"
                    >
                      <b-form-group label="Designation" label-for="designation">
                        <b-form-input
                          id="designation"
                          v-model="data.designation"
                          :state="getValidationState(validationContext)"
                          placeholder=""
                          :disabled="disableForm"
                        />

                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col cols="3">
                    <div
                      style="
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-evenly;
                      "
                    >
                      <b-button
                        v-if="index !== 0"
                        size="sm"
                        variant="outline-danger"
                        class="mr-1"
                        @click="deleteDesignation(index)"
                      >
                        <feather-icon
                          size="15"
                          icon="TrashIcon" 
                        />
                      </b-button>

                      <b-button
                        v-if="
                          new_data.designations.length === 1 ||
                          index === new_data.designations.length - 1
                        "
                        size="sm"
                        variant="outline-primary"
                        class=""
                        @click="addNewDesignation()"
                      >
                        <feather-icon
                          size="15"
                          icon="PlusIcon"
                        />
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>

              <!-- is cop_area_head -->

              <b-form-group label="Is this COP Area Head?" label-for="is_cop_area_head" class="mb-2">
                <validation-provider
                  #default="{ errors }"
                  name="is_cop_area_head"
                  rules=""
                >
                  <b-form-checkbox
                    id="cop_member"
                    v-model="new_data.is_cop_area_head"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
                :disabled="disableForm"
              >
                {{ isUpdate ? "Update" : "Add" }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
BAlert,
BButton,
BCardText,
BCol,
BForm,
BFormGroup,
BFormInput,
BFormInvalidFeedback,
BFormTextarea,
BIcon,
BIconPlusCircle,
BIconTrash,
BModal,
BOverlay,
BRow,
BSidebar,
BFormCheckbox,
} from "bootstrap-vue";

import { required } from "@validations";
import { cloneDeep, get, omit } from "lodash";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";

const rawEventCenterBlockData = {
  designations: [
    {
      designation: "",
    },
  ],
  member_type_id: "",
  is_cop_area_head: false
};

export default {
  components: {
    BFormCheckbox,
    BOverlay,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BAlert,
    BCardText,
    vSelect,
    BModal,
    BRow,
    BCol,
    BIcon,
    BIconTrash,
    BIconPlusCircle,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddOrUpdateActive",
    event: "update:is-add-or-update-active",
  },
  props: {
    isAddOrUpdateActive: {
      type: Boolean,
      required: true,
    },
    participantTypes: {
      required: true,
      type: Array,
    },
    updateData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      required,
      loading: false,
      errorMessage: "",
      event_centers: [],
      new_data: cloneDeep(rawEventCenterBlockData),
      update_data: {},
    };
  },
  computed: {
    isUpdate() {
      return !!this.updateData;
    },
    disableForm() {
      if (this.isUpdate) {
        return !this.can("member_designations:CanUpdate");
      }

      return !this.can("member_designations:CanAddNew");
    },
  },
  watch: {
    updateData: {
      handler(updateData) {
        if (updateData) {
          this.update_data = {
            _id: updateData._id,
            designation: updateData.designation,
            member_type_id: updateData.member_type_id,
            is_cop_area_head: updateData.is_cop_area_head
          };
        }
      },
      immediate: true,
      deep: true,
    },

    isAddOrUpdateActive: {
      handler(isAddOrUpdateActive) {
        if (isAddOrUpdateActive && !this.isUpdate) {
          this.new_data = cloneDeep(rawEventCenterBlockData);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async onCreateOrUpdate() {
      try {
        this.loading = true;
        this.errorMessage = "";

        const success = await this.$refs.update_modal_form.validate();
        if (!success) {
          return;
        }

        const messages = {
          update: {
            title: "Confirm Designation Update",
            text: "You are about to update details of a designation.",
            icon: "warning",
          },
          new: {
            title: "Create Designation",
            text: "You are about to create a designation",
            icon: "info",
          },
        };

        /* eslint-disable no-nested-ternary */
        const message = this.isUpdate ? messages.update : messages.new;
        const { title, text, icon } = message;

        const result = await this.$swal({
          title,
          text,
          icon,
          showCancelButton: true,
          confirmButtonText: "Yes, proceed.",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          return;
        }

        if (this.isUpdate) {
          const title_id = this.update_data._id;
          const update_data = omit(this.update_data, "_id");
          if (!this.can("member_designations:CanUpdate")) {
            return;
          }
          await this.useJwt().mainService.memberDesignations.update(
            title_id,
            update_data
          );
        } else {
          if (!this.can("member_designations:CanAddNew")) {
            return;
          }
          await this.useJwt().mainService.memberDesignations.create(this.new_data);
        }
        this.$emit("refetchData");
        this.$emit("update:is-add-or-update-active", false);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success!",
            icon: "AlertQuestionIcon",
            variant: "success",
            text: `Designation ${
              this.isUpdate ? "updated" : "added"
            } successfully`,
          },
        });
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.$emit("resetUpdateData");
      this.new_data = {};
      if (this.$refs.update_modal_form) {
        this.$refs.update_modal_form.reset();
      }
    },

    addNewDesignation() {
      this.new_data.designations.push({
        designation: "",
      });
    },
    deleteDesignation(index) {
      this.new_data.designations.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#add-or-update-event-block {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
